import React, { useState } from 'react';
import { useRouteError } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <Helmet>
        <title>404 — Η σελίδα δε βρέθηκε | zuper</title>
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={`https://www.zuper-market.gr${location.pathname}`} />
      </Helmet>
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
